import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { formatUsd } from '@/utils/vehicleFormat';

import { type DeliveryWeightBand } from '../hooks/useDeliveryRoutes';

/**
 * One weight band and its price, as a row of a definition list.
 *
 * A `<dl>` rather than a table: each row is one term and one figure, and a
 * two-column table of five rows asks a screen reader to announce column
 * headers for a pairing the markup can state outright.
 */
export function RoutePriceRow({ band, last }: { band: DeliveryWeightBand; last: boolean }) {
  return (
    <Stack
      direction="row"
      spacing={4}
      alignItems="baseline"
      justifyContent="space-between"
      sx={{
        py: 3,
        borderBottom: last ? 0 : 1,
        borderColor: 'divider',
      }}
    >
      <Typography component="dt" variant="body2" color="text.secondary" sx={{ minWidth: 0 }}>
        {band.label}
      </Typography>
      <Typography
        component="dd"
        variant="subtitle2"
        sx={{ m: 0, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}
      >
        {formatUsd(band.amountUsd)}
      </Typography>
    </Stack>
  );
}
